import React from 'react';
import { useAuth } from '../context/AuthContext';
import UtilityDashboard from './UtilityDashboard';
import SubBrokerDashboard from './SubBrokerDashboard';

/**
 * DashboardRouter component that renders the appropriate dashboard
 * based on the user's role
 */
const DashboardRouter: React.FC = () => {
  const { user } = useAuth();

  // If user role is 'user', show SubBrokerDashboard
  // Otherwise, show the standard UtilityDashboard
  if (user?.role === 'user') {
    return <SubBrokerDashboard />;
  }

  return <UtilityDashboard />;
};

export default DashboardRouter;
